<template>
  <v-card
    class="mx-auto main-layout"
    :max-width="maxWidth"
  >
    <v-toolbar
      class="print-hidden"
      color="primary"
      dark
    >
      <slot name="buttons-prepend"></slot>
      <v-spacer></v-spacer>
      <v-toolbar-title
        class="layout-title"
        v-html="title"
      ></v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="buttons"></slot>
    </v-toolbar>
    <v-sheet class="print-only" height="60"></v-sheet>
    <slot name="content"></slot>
    <div class="print-only print-only--footer">
      https://dcp.su/growth/
    </div>
    <v-sheet class="print-only" height="40"></v-sheet>
  </v-card>
</template>

<script>
import config from '~/app/config'

export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  computed: {
    maxWidth () {
      return config.maxWidth
    }
  },
  mounted () {
    // We listen to the resize event
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  unmounted () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
}
</script>

<style lang="stylus" type="text/stylus">
  @import "../assets/stylus/app.styl"
  .main-layout
    min-height 100vh /* Fallback for browsers that do not support Custom Properties */
    min-height calc(var(--vh, 1vh) * 100 - 56px)

  @media (orientation: portrait)
    .main-layout
      width 100vw
      height 100vh /* Fallback for browsers that do not support Custom Properties */
      height calc(var(--vh, 1vh) * 100)
      box-shadow none !important

  .container
    padding 0
    min-width 320px

  .layout-title
    line-height 1
    text-align center

  .print-only
    display none
    &-inline
      display none
    &--footer
      text-align center
      font-size small
      color black
      font-weight bold
      z-index 4
      padding 25px 0 15px
      position relative

  @media print
    .print-only
      display block !important
    .print-only-inline
      display inline !important
    .print-hidden
      display none !important
    .v-bottom-navigation
      display none !important
    .main-layout
      width 1000px !important
      height 1400px !important
      padding 0 40px
      box-sizing content-box
      overflow hidden
    .measure-graph__line
      padding 20px 15px 5px
      min-height auto !important
    .measure-graph
      width 1000px !important
      height 1340px !important
       canvas
        visibility hidden
    .printed-image
      width 960px
      height 1240px
      padding 0
      margin auto
    .measure-graph__table
      margin-left 0
      margin-top 0
      width 493px !important
      min-height 185px !important
    .v-data-table
      padding 15px
    .v-data-footer
      display none
    .v-sheet
      box-shadow none !important

    @page {
      size 210mm 297mm
      margin 0
    }
</style>
